import React, { useEffect, useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { useAuth } from "../context/AuthContext";

export default function Damaged() {
  const { isAdmin } = useAuth();
  const [records, setRecords] = useState([]);
  const [totalLoss, setTotalLoss] = useState(0);
  const [products, setProducts] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({
    productId: "",
    color: "",
    quantity: 1,
    reason: "",
  });
  const [selectedProduct, setSelectedProduct] = useState(null);

  const fetchData = async () => {
    const [dmg, prods] = await Promise.all([
      axios.get("https://vape-backend-1.onrender.com/api/damaged"),
      axios.get("https://vape-backend-1.onrender.com/api/products"),
    ]);
    setRecords(dmg.data.damaged);
    setTotalLoss(dmg.data.totalLoss);
    setProducts(prods.data);
  };
  useEffect(() => {
    fetchData();
  }, []);

  const handleProductChange = (id) => {
    const p = products.find((x) => x._id === id);
    setSelectedProduct(p);
    setForm({ ...form, productId: id, color: "" });
  };

  const submit = async () => {
    if (!form.productId || !form.color || form.quantity < 1)
      return toast.error("Fill all fields");
    try {
      await axios.post("https://vape-backend-1.onrender.com/api/damaged", form);
      toast.success(isAdmin ? "Damage recorded!" : "Submitted for approval!");
      setShowModal(false);
      setForm({ productId: "", color: "", quantity: 1, reason: "" });
      setSelectedProduct(null);
      fetchData();
    } catch (err) {
      toast.error(err.response?.data?.message || "Error");
    }
  };

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">Damaged Goods</h1>
          <p className="page-subtitle">
            Record and track damaged/lost inventory
          </p>
        </div>
        <button className="btn btn-danger" onClick={() => setShowModal(true)}>
          + Record Damage
        </button>
      </div>

      <div className="stat-grid">
        <div className="stat-card red">
          <div className="stat-label">Total Loss</div>
          <div className="stat-value">৳{totalLoss.toLocaleString()}</div>
          <div className="stat-sub">{records.length} damage records</div>
        </div>
      </div>

      {/* Desktop table */}
      <div className="card hide-mobile">
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Product</th>
                <th>Category</th>
                <th>Model</th>
                <th>Color</th>
                <th>Qty</th>
                <th>Buy Price</th>
                <th>Total Loss</th>
                <th>Reason</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {records.length === 0 && (
                <tr>
                  <td colSpan={9}>
                    <div className="empty-state">
                      <div className="icon">⚠️</div>
                      <p>No damage records</p>
                    </div>
                  </td>
                </tr>
              )}
              {records.map((r) => (
                <tr key={r._id}>
                  <td style={{ fontWeight: 600 }}>{r.productName}</td>
                  <td style={{ color: "var(--text-secondary)" }}>
                    {r.category}
                  </td>
                  <td style={{ color: "var(--text-secondary)" }}>{r.model}</td>
                  <td>
                    <span
                      className="badge-color"
                      style={{ background: "var(--bg-hover)" }}
                    >
                      {r.color}
                    </span>
                  </td>
                  <td>{r.quantity}</td>
                  <td style={{ color: "var(--text-secondary)" }}>
                    ৳{r.buyPrice}
                  </td>
                  <td className="text-loss" style={{ fontWeight: 600 }}>
                    ৳{r.totalLoss?.toLocaleString()}
                  </td>
                  <td
                    style={{
                      color: "var(--text-secondary)",
                      fontSize: "0.82rem",
                    }}
                  >
                    {r.reason || "—"}
                  </td>
                  <td
                    style={{ color: "var(--text-muted)", fontSize: "0.78rem" }}
                  >
                    {new Date(r.damagedAt).toLocaleDateString("en-BD")}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Mobile cards */}
      <div className="show-mobile">
        {records.length === 0 && (
          <div className="card">
            <div className="empty-state">
              <div className="icon">⚠️</div>
              <p>No damage records</p>
            </div>
          </div>
        )}
        {records.map((r) => (
          <div
            className="card"
            key={r._id}
            style={{ marginBottom: 10, padding: 14 }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                marginBottom: 10,
              }}
            >
              <div>
                <div style={{ fontWeight: 700, fontSize: "0.92rem" }}>
                  {r.productName}
                </div>
                <div
                  style={{
                    fontSize: "0.76rem",
                    color: "var(--text-secondary)",
                    marginTop: 2,
                  }}
                >
                  {r.category} · {r.model}
                </div>
              </div>
              <span
                className="badge-color"
                style={{ background: "var(--bg-hover)", flexShrink: 0 }}
              >
                {r.color}
              </span>
            </div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 6,
                fontSize: "0.8rem",
                marginBottom: 8,
              }}
            >
              <div
                style={{
                  background: "var(--bg-primary)",
                  borderRadius: 6,
                  padding: "6px 10px",
                }}
              >
                <div
                  style={{
                    color: "var(--text-muted)",
                    fontSize: "0.68rem",
                    marginBottom: 2,
                  }}
                >
                  QTY
                </div>
                <strong>{r.quantity}</strong>
              </div>
              <div
                style={{
                  background: "var(--bg-primary)",
                  borderRadius: 6,
                  padding: "6px 10px",
                }}
              >
                <div
                  style={{
                    color: "var(--text-muted)",
                    fontSize: "0.68rem",
                    marginBottom: 2,
                  }}
                >
                  TOTAL LOSS
                </div>
                <strong className="text-loss">
                  ৳{r.totalLoss?.toLocaleString()}
                </strong>
              </div>
            </div>
            {r.reason && (
              <div
                style={{
                  fontSize: "0.78rem",
                  color: "var(--text-secondary)",
                  marginBottom: 6,
                }}
              >
                📝 {r.reason}
              </div>
            )}
            <div style={{ fontSize: "0.73rem", color: "var(--text-muted)" }}>
              {new Date(r.damagedAt).toLocaleDateString("en-BD")}
            </div>
          </div>
        ))}
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <h3>Record Damage</h3>
            <div className="form-group">
              <label>Product</label>
              <select
                value={form.productId}
                onChange={(e) => handleProductChange(e.target.value)}
              >
                <option value="">Select product...</option>
                {products.map((p) => (
                  <option key={p._id} value={p._id}>
                    {p.name} — {p.model}
                  </option>
                ))}
              </select>
            </div>
            {selectedProduct && (
              <div className="form-group">
                <label>Color</label>
                <select
                  value={form.color}
                  onChange={(e) => setForm({ ...form, color: e.target.value })}
                >
                  <option value="">Select color...</option>
                  {selectedProduct.colors.map((c) => (
                    <option
                      key={c.color}
                      value={c.color}
                      disabled={c.stock === 0}
                    >
                      {c.color} (Stock: {c.stock})
                    </option>
                  ))}
                </select>
              </div>
            )}
            <div className="grid-2">
              <div className="form-group">
                <label>Quantity</label>
                <input
                  type="number"
                  value={form.quantity}
                  onChange={(e) =>
                    setForm({ ...form, quantity: +e.target.value })
                  }
                  min="1"
                />
              </div>
              <div className="form-group">
                <label>Reason</label>
                <input
                  value={form.reason}
                  onChange={(e) => setForm({ ...form, reason: e.target.value })}
                  placeholder="e.g. Broken, Lost..."
                />
              </div>
            </div>
            <div className="modal-actions">
              <button
                className="btn btn-ghost"
                onClick={() => setShowModal(false)}
              >
                Cancel
              </button>
              <button className="btn btn-danger" onClick={submit}>
                {isAdmin ? "Record Damage" : "Submit for Approval"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
